import { API_METHODS, BASE_URL, createHeader } from '../endpointBuilder';
import { axiosRequest } from '../request';
import {
	IUserProfileFields,
	User,
	UserChangePasswordDTO,
} from '../../lib/interfaces/User';

const endpoints = {
	updateUserProfile: (data: Partial<IUserProfileFields>) => ({
		headers: createHeader(null, true),
		url: `${BASE_URL}/user`,
		method: API_METHODS.PATCH,
		data,
	}),
	changePassword: (data: UserChangePasswordDTO) => ({
		headers: createHeader(null, true),
		url: `${BASE_URL}/auth/updatePassword`,
		method: API_METHODS.POST,
		data,
	}),
	getTrainingApisToken: () => ({
		headers: createHeader(null, true),
		url: `${BASE_URL}/user/generate-cw-training-token`,
		method: API_METHODS.GET,
	}),
};

export const updateUserProfile = async (data: Partial<IUserProfileFields>) =>
	axiosRequest(endpoints.updateUserProfile(data));

export const changePassword = async (data: UserChangePasswordDTO) =>
	axiosRequest(endpoints.changePassword(data));

export const changeSubscriptionPlan = async (data: Partial<User>) =>
	axiosRequest(endpoints.updateUserProfile(data));

export const getTrainingApisToken = async () =>
	axiosRequest(endpoints.getTrainingApisToken());
